/**
 * Converts a timestamp to a formatted date string which can be used with an HTML 5 datetime-local input
 *
 * @param {number} timestamp - The timestamp to convert.
 * @returns {string} The formatted date string.
 */
function timestampToDateString(timestamp : number | undefined) : string
{
    if (timestamp === undefined || timestamp === 0) {
        return "";
    }

    const isoString = new Date(timestamp).toISOString();
    return isoString.substring(0, isoString.indexOf("T") + 6);
}

/**
 * Converts a date string to a timestamp
 *
 * @param {string} date - The date string to convert
 * @return {number} The timestamp value representing the given date string,
 *                  or 0 if the date string is undefined or empty
 */
function dateStringToTimestamp(date : string) : number
{
    if (date === undefined || date.length === 0) {
        return 0;
    }

    return Date.parse(date);
}

/**
 * Converts a timestamp to a short date and time string.
 *
 * @param {number} timestamp - The timestamp to convert.
 * @return {string} - The short date and time string representation of the timestamp.
 */
function timestampToDateStringShort(timestamp : number | undefined) : string
{
    if (timestamp === undefined || timestamp === null || timestamp === 0) {
        return "";
    }

    return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
    }).format(timestamp)
}

/**
 * Converts a timestamp to a short date and time string.
 *
 * @param {number} timestamp - The timestamp to convert.
 * @return {string} - The short date and time string representation of the timestamp.
 */
function timestampToUTCString(timestamp : number | undefined) : string
{
    if (timestamp === undefined || timestamp === null || timestamp === 0) {
        return "";
    }

    const d = new Date(timestamp).toISOString().split('T')
    const date = d[0];
    const time = d[1].split('.')[0];

    return `${date} ${time}`
}

export const DateUtils = () => {
    return
}

DateUtils.timestampToDateString = timestampToDateString;
DateUtils.dateStringToTimestamp = dateStringToTimestamp;
DateUtils.timestampToDateStringShort = timestampToDateStringShort;
DateUtils.timestampToUTCString = timestampToUTCString;